import React, { useEffect } from "react";
import InfoIconOutlined from "@mui/icons-material/InfoOutlined";
import { UseAppDispatch } from "redux/store";
import { useSelector } from "react-redux";
import {
  updatePassengers,
  searchFormSelector,
  ISearchPassengers,
} from "redux/searchForm";
import { useTranslations } from "hooks/useTranslations";
import { ITravellerType } from "@thekilroygroup/shared-ui";
import {
  Box,
  Typography,
  ListItem,
  Tooltip,
  Divider,
  List,
  Stack,
  SxProps,
} from "@mui/material";
import Counter from "../../Counter/Counter";

export default function PassengerTypes() {
  let { passengers } = useSelector(searchFormSelector);
  const dispatch = UseAppDispatch();
  const { translations } = useTranslations();
  const translationsWho = translations.search.who;
  const handleCount = (value: number, id: string) => {
    let nextPassengers: any = { ...passengers };
    nextPassengers[id] = value;
    dispatch(updatePassengers(nextPassengers));
  };

  useEffect(() => {
    if (passengers.adults < passengers.infants) {
      let nextPassengers: ISearchPassengers = { ...passengers };
      nextPassengers.infants = passengers.adults;
      dispatch(updatePassengers(nextPassengers));
    }
  }, [passengers.adults]);

  const passengersArr: ITravellerType[] = ["adults", "children", "infants"];

  const getMaxAmount = (item: ITravellerType) => {
    const maxAmount = translationsWho.maxAmount;
    let sumTheOthers = 0;
    for (const key in passengers) {
      if ((key as keyof ISearchPassengers) !== item) {
        sumTheOthers += passengers[key as keyof ISearchPassengers];
      }
    }

    let maxVal = 0;
    if (sumTheOthers <= maxAmount) {
      maxVal = maxAmount - sumTheOthers;
    } else {
      maxVal = passengers[item as keyof ISearchPassengers];
    }

    if (item === "infants" && maxVal >= passengers.adults) {
      maxVal = passengers.adults;
    }
    return maxVal;
  };

  const getMinAmount = (item: ITravellerType) => {
    if (item === "adults") return 1;
    return 0;
  };

  const { passengersTypes, list, listItem } = sxStyles;
  return (
    <Box sx={passengersTypes}>
      <Typography variant="h5" color={"primary.main"}>
        {translationsWho.passengerTypes.title}
      </Typography>

      <List sx={list}>
        {passengersArr.map((item: ITravellerType, i) => {
          const { title, age, disclaimerText } =
            translationsWho.passengerTypes.passengers[
              item as keyof ISearchPassengers
            ];

          const value = passengers[item as keyof ISearchPassengers];

          return (
            <Box key={`${i}-list-item`}>
              <ListItem disableGutters sx={listItem}>
                <Stack direction="row" width={1} justifyContent="space-between">
                  <Typography
                    variant="bodyMedium"
                    fontWeight="600"
                    sx={{
                      mr: 2,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {title}{" "}
                    {disclaimerText && (
                      <Tooltip title={disclaimerText}>
                        <InfoIconOutlined fontSize="small" sx={{ ml: 0.5 }} />
                      </Tooltip>
                    )}
                  </Typography>
                  <Counter
                    onChange={handleCount}
                    id={item}
                    initialValue={value}
                    minValue={getMinAmount(item)}
                    maxValue={getMaxAmount(item)}
                  />
                </Stack>
                <Typography variant="bodyMedium" color={"grey.700"}>
                  {age}
                </Typography>
              </ListItem>
              <Divider sx={{ borderColor: "grey.200" }} />
            </Box>
          );
        })}
      </List>
    </Box>
  );
}

const sxStyles: { [key: string]: SxProps } = {
  passengersTypes: {
    pt: { xs: 2, md: 0 },
    width: { md: 0.5 },
  },
  list: {
    width: "100%",
    mb: { xs: 5.25, md: 1 },
    borderRight: { md: `1px solid` },
    borderColor: { md: "grey.200" },
    pt: { md: 2 },
    pr: { md: 2 },
    pb: { md: 0 },
  },
  listItem: {
    mb: 1,
    pb: 0,
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
};
